import { Component } from "react";

class XLPOffers extends Component {
  render() {
    return (
      <>
        <section className="py-5" style={{ backgroundColor: "#fffaf8" }}>
          <div className="container py-lg-5 text-center">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8">
                {/* 1. Dynamic Title */}
                <h2 className="display-6 text-dark mb-3">{this.props.title}</h2>
                {/* 2. Dynamic Description */}
                {this.props.description && (
                  <p className="text-secondary lead fw-normal">
                    {this.props.description}
                  </p>
                )}
              </div>
            </div>
            {/* 3. Dynamic Image */}
            <div className="mb-5 mx-auto col-lg-8">
              <img
                src={this.props.imageSrc}
                alt={this.props.imageAlt || "XLP Feature"}
                className="img-fluid mb-5 rounded-4"
                style={
                  this.props.imageStyle || { maxWidth: "100%", height: "auto" }
                }
              />
            </div>
            {/* 4. Dynamic Button */}
            {this.props.button && (
              <div
                className="text-end"
                style={{ maxWidth: "900px", margin: "0 auto" }}
              >
                <a
                  href={this.props.buttonLink || "#"}
                  className="btn btn-brand px-4 py-2"
                >
                  {this.props.button}
                </a>
              </div>
            )}
          </div>
        </section>
      </>
    );
  }
}

export default XLPOffers;
